import { NavLink } from "react-router-dom";
import AccountManage from "./AccountManage";
import User from "../../services/user.jsx";
import { useEffect, useState } from "react";

function Nav() {
  const [userPermissions, setUserPermissions] = useState(User.permissions());

  // 监听权限变化
  useEffect(() => {
    const updatePermissions = () => {
      setUserPermissions(User.permissions());
    };

    window.addEventListener('userPermissionsChanged', updatePermissions);

    return () => {
      window.removeEventListener('userPermissionsChanged', updatePermissions);
    };
  }, []);

  return (
    <nav>
      <ul>
        {userPermissions?.permissions?.includes("affiliates:list") && (
          <li>
            <NavLink activeClassName="active" to="/affiliates">
              {/* Affiliates */}
              AFFILIATES
            </NavLink>
          </li>
        )}
        {userPermissions?.permissions?.includes("clients:list") && (
          <li>
            <NavLink activeClassName="active" to="/clients">
              {/* Clients */}
              CLIENTS
            </NavLink>
          </li>
        )}
        {userPermissions?.permissions?.includes("devices:list") && (
          <li>
            <NavLink activeClassName="active" to="/devices">
              {/* Devices */}
              DEVICES
            </NavLink>
          </li>
        )}
        {userPermissions?.permissions?.includes("campaigns:list") && (
          <li>
            <NavLink activeClassName="active" to="/campaigns">
              {/* Campaigns */}
              CAMPAIGNS
            </NavLink>
          </li>
        )}
        {(userPermissions?.permissions?.includes("playlists:list") ||
          userPermissions?.permissions?.includes("collections:list")) && (
          <li>
            <NavLink activeClassName="active" to="/assets">
              {/* Playlists */}
              PLAYLISTS
            </NavLink>
          </li>
        )}
        {(userPermissions?.permissions?.includes("users:list") ||
          userPermissions?.permissions?.includes("roles:list")) && (
          <li>
            <NavLink activeClassName="active" to="/users/list">
              {/* Users */}
              USERS
            </NavLink>
          </li>
        )}

        <li>
          <AccountManage />
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
